import _ from 'lodash';

/**
 * Returns an object containing a map of { CONSTANT: 'prefix/CONSTANT' } items.
 * Useful for bulk creating action constants and adding all of them to an object,
 * so they can be easily referenced from outside.
 *
 * Example:
 *
 * ```
 * createPrefixedActions(
 *   'login',
 *   `
 *    SUBMIT_LOGIN
 *    RESET_RESULT
 *    SESSION_TIMED_OUT
 *   `
 * );
 * ```
 *
 * Will create an object with the following value:
 * {
 *   SUBMIT_LOGIN: 'login/SUBMIT_LOGIN',
 *   RESET_RESULT: 'login/RESET_RESULT',
 *   SESSION_TIMED_OUT: 'login/SESSION_TIMED_OUT',
 * }
 *
 * @param {string} prefix
 * @param {string} constants
 */
const createPrefixedActions = (prefix: string, constants: string) => {
  return _.fromPairs(
    constants
      .split(/[ \n]+/)
      .filter(part => part)
      .map(part => [part, prefix ? `${prefix}/${part}` : part])
  );
};

export default createPrefixedActions;
